import React from "react"
import { Box } from "@mui/material"

import { AppDialogCancel, AppFormDrawer, AppFormGrid, AppFormSection } from "@components"
import { isEditUserSettingsProvidersDrawer, isOpenUserSettingsProvidersDrawer, userSettingProvidersFormData } from "../../../@signals"
import UserSettingProviderDrawerColor from "./Color"
import UserSettingProviderDrawerProviders from "./Providers"
import UserSettingProviderDrawerSubmit from "./Submit"


export default function UserSettingProviderDrawer() {
	const onClose = () => userSettingProvidersFormData.value = { }

	return <AppFormDrawer
		icon="palette"
		title={isEditUserSettingsProvidersDrawer.value ? 'Edit provider' : 'New provider'}
		subtitle="A provider and its colour"
		isOpen={isOpenUserSettingsProvidersDrawer.value}
		controller={onClose}
		footer={<>
			<AppDialogCancel onClick={onClose}/>
			<UserSettingProviderDrawerSubmit/>
		</>}
	>
		<AppFormSection icon="palette" title="Provider">
			<AppFormGrid>
				<Box sx={{ gridColumn: 'span 12' }}><UserSettingProviderDrawerProviders/></Box>
				<Box sx={{ gridColumn: 'span 12' }}><UserSettingProviderDrawerColor/></Box>
			</AppFormGrid>
		</AppFormSection>
	</AppFormDrawer>
}
